import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "font-weight-bold mb-4" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-header header-elements-inline" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Wählen Sie ein Objekt")
], -1)
const _hoisted_5 = { class: "media-list media-list-linked media-list-bordered" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "mr-3 align-self-center d-flex flex-column align-items-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", { class: "btn bg-transparent rounded-pill border-2 btn-icon border-primary text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-store" })
], -1)
const _hoisted_9 = { class: "text-primary" }
const _hoisted_10 = { class: "media-body align-self-center d-flex flex-column" }
const _hoisted_11 = { class: "d-flex flex-row flex-wrap" }
const _hoisted_12 = { class: "text-muted mr-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "list-icons" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "list-icons-item"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right15" })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.headline), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: ""
          }, [
            _createElementVNode("a", {
              class: "media cursor-pointer align-items-center",
              onClick: ($event: any) => (_ctx.nextStep(item.pid))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("small", _hoisted_9, "#" + _toDisplayString(item.pid), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createTextVNode(_toDisplayString(item.p_firma) + " | " + _toDisplayString(item.p_ort) + " ", 1),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(item.p_strasse) + " " + _toDisplayString(item.p_hnr), 1)
                ])
              ]),
              _hoisted_13
            ], 8, _hoisted_6)
          ]))
        }), 128))
      ])
    ])
  ]))
}